import { render, staticRenderFns } from "./UsageLatencyChart.vue?vue&type=template&id=63b12f2b"
import script from "./UsageLatencyChart.vue?vue&type=script&lang=js"
export * from "./UsageLatencyChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports